<template>
  <div class="card mb-4">
    <!-- Shipment Details Section -->
    <div class="card-body box-shadow-1" style="border-radius: 8px;">
      <div class="table-responsive">
        <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
          <div class="row">
            <div class="col-sm-12">
              <p class="mb-3">{{ $t("shipment_details") }}</p>

              <table class="table">
                <thead class="data-table-bg">
                  <tr>
                    <th>{{ $t("reference") }}</th>
                    <th>{{ $t("loading-date") }}</th>
                    <th>{{ $t("eta") }}</th>
                    <th>{{ $t("departure-date") }}</th>
                    <th>{{ $t("vessel-name") }}</th>
                    <th>{{ $t("point-of-arrival") }}</th>
                    <th>{{ $t("actions") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ shipmentDetails.reference }}</td>
                    <td>{{ shipmentDetails.loadingDate }}</td>
                    <td>{{ shipmentDetails.eta }}</td>
                    <td>{{ shipmentDetails.departureDate }}</td>
                    <td>{{ shipmentDetails.vesselName }}</td>
                    <td>{{ shipmentDetails.pointOfArrival }}</td>
                    <td>
                      <span
                        class="cursor-pointer"
                        @click="$emit('goToStep', 1)"
                      >
                        <IconEdit />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body mt-3 mb-3 box-shadow-1" style="border-radius: 8px;">
      <div class="table-responsive">
        <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
          <div class="row">
            <div class="col-sm-12">
              <p class="mb-3">{{ $t("container_details") }}</p>

              <table class="table">
                <thead class="data-table-bg">
                  <tr>
                    <th>{{ $t("product") }}</th>
                    <th>{{ $t("no-of-pallet") }}</th>
                    <th>{{ $t("container_number") }}</th>
                    <th>{{ $t("no-of-devices") }}</th>
                    <th>{{ $t("actions") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :key="index"
                    v-for="(container, index) in containers"
                    class="container-details"
                    :class="{
                      'data-table-bg': index % 2 !== 0,
                    }"
                  >
                    <td>{{ container.product }}</td>
                    <td>{{ container.pallet }}</td>
                    <td>{{ container.containerNumber }}</td>
                    <td>{{ container.assignedDevices.length }}</td>
                    <td style="display: flex; align-items: center; gap: 0.5rem; ">
                      <span
                        class="cursor-pointer"
                        @click="$emit('goToStep', 2)"
                      >
                        <IconEdit />
                      </span>
                      <span
                        v-if="containers.length > 1"
                        class="cursor-pointer"
                        @click="$emit('delete_containerDetails', index)"
                      >
                        <IconDeleteUser />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="display: flex; justify-content: center;">
      <div class="col-sm-8 col-12 box-shadow-1" style="border-radius: 8px;">
        <!-- Origin Section -->
        <div class="card mb-4">
          <div>
            <div class="table-responsive">
              <div
                class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
              >
                <div class="row">
                  <div class="col-sm-12">
                    <p class="mb-3 mt-3">Origin</p>

                    <table class="table">
                      <thead class="data-table-bg">
                        <tr>
                          <th>{{ $t("name") }}</th>
                          <th>{{ $t("address") }}</th>
                          <th>{{ $t("region") }}</th>
                          <th>{{ $t("country") }}</th>
                          <th>{{ $t("actions") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ origin.name }}</td>
                          <td>{{ origin.address.name }}</td>
                          <td>{{ origin.region }}</td>
                          <td>{{ origin.country }}</td>
                          <td>
                            <span
                              class="cursor-pointer"
                              @click="$emit('goToStep', 3)"
                            >
                              <IconEdit />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Destination Section -->
        <div class="card mb-4">
          <div>
            <!-- <p class="mb-3">Destination</p> -->
            <div class="table-responsive">
              <div
                class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
              >
                <div class="row">
                  <div class="col-sm-12">
                    <p class="mb-3">Destination</p>

                    <table class="table">
                      <thead class="data-table-bg">
                        <tr>
                          <th>{{ $t("name") }}</th>
                          <th>{{ $t("person-of-contact") }}</th>
                          <th>{{ $t("region") }}</th>
                          <th>{{ $t("country") }}</th>
                          <th>{{ $t("address") }}</th>
                          <th>{{ $t("actions") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ destination.name }}</td>
                          <td>{{ destination.personOfContact }}</td>
                          <td>{{ destination.region }}</td>
                          <td>{{ destination.country }}</td>
                          <td>{{ destination.address ? destination.address .name : "-" }}</td>
                          <td>
                            <span
                              class="cursor-pointer"
                              @click="$emit('goToStep', 3)"
                            >
                              <IconEdit />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4 col-12">
        <!-- Map Section -->
        <map-direction
          class="card-body h-100"
          :start="originLatLng"
          :end="destinationLatLng"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IconEdit from "../../../components/Iconsvg/IconEditUser.vue";
import IconDeleteUser from "../../../components/Iconsvg/IconDeleteUser.vue";

import MapDirection from "./MapDirection.vue";

export default {
  components: {
    IconEdit,
    MapDirection,
    IconDeleteUser,
  },
  name: "Summary",
  props: {
    origin: {
      type: Object,
      default: () => ({}),
    },
    destination: {
      type: Object, 
      default: () => ({}),
    },
    shipmentDetails: {
      type: Object,
      default: () => ({}),
    },
    containers: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
  console.log("Initial shipmentDeets:", this.shipmentDetails);
},
  computed: {
    originLatLng() {
      const { lat, lng } = this.origin.address || {};
      return { lat, lng };
    },
    destinationLatLng() {
      if (this.destination.address) {
        const { lat, lng } = this.destination.address;
        return { lat, lng };
      } else {
        const { lat, lng } = this.shipmentDetails;
        return lat && lng ? { lat, lng } : null;
      }
    },
  },
  methods: {
    isValidLatLng(lat, lng) {
      return (
        typeof lat === "number" &&
        typeof lng === "number" &&
        !isNaN(lat) &&
        !isNaN(lng)
      );
    },
  }
};
</script>

<style scoped>
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  background-color: transparent;
}

.data-table-bg {
  background-color: #f8f9fa;
}

.cursor-pointer {
  cursor: pointer;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.col-gap-1 {
  gap: 1rem;
}

.row {
  margin-left: 0;
}
</style>
